jQuery( document ).ready( function( $ ) {
  // Show / hide address add form
  $( '.customer--addresses .add-address' ).on( 'click', function( e ) {
    $( '#address-add' ).toggle();
    $( '#address-list' ).toggle();
  } );

  // Show / hide address add form
  $( '.customer--addresses .add-address-cancel' ).on( 'click', function( e ) {
    $( '#address-add' ).toggle();
    $( '#address-list' ).toggle();
  } )
});